"use client";

import { c as _c } from "react/compiler-runtime";
import { Carousel, type CarouselApi, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@repo/design-system/components/ui/carousel";
import { useActiveSection } from "@repo/design-system/hooks/use-active-section";
import { cn } from "@repo/design-system/utils/cn";
import { filterAndSortByDomOrder } from "@repo/design-system/utils/helpers";
import { type KeyboardEvent, type MouseEvent, useEffect, useMemo, useRef, useState } from "react";
import { useMediaQuery } from "usehooks-ts";
import { ApplyButton } from "~/components/ui/apply-button-eon";
import type { TranslationsMap } from "~/translations/loader/init";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
const SCROLL_OFFSET = 120;
const handleNavigation = (e: MouseEvent<HTMLAnchorElement> | KeyboardEvent<HTMLAnchorElement>) => {
  e.preventDefault();
  const href = e.currentTarget.getAttribute("href");
  if (!href) {
    return;
  }
  const element = document.querySelector(href);
  if (!element) {
    return;
  }
  const y = element.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET;
  window.scrollTo({
    top: y,
    behavior: "smooth"
  });
};
const applyButtonClass = "rounded-lg border border-primary bg-white font-bold text-primary transition-colors duration-150 hover:bg-primary hover:text-white";
export default function SectionBarHungary(t0) {
  const $ = _c(44);
  const {
    job,
    config
  } = t0;
  const t = useLanguage();
  const [api, setApi] = useState();
  const [domReady, setDomReady] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const isLarge = useMediaQuery("(min-width: 1024px)");
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setDomReady(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  config?.sectionBarItems;
  let t3;
  bb0: {
    let t4;
    if ($[2] !== config?.sectionBarItems) {
      t4 = config?.sectionBarItems || [];
      $[2] = config?.sectionBarItems;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    const items = t4;
    if (!domReady) {
      t3 = items;
      break bb0;
    }
    let t5;
    if ($[4] !== items) {
      t5 = filterAndSortByDomOrder(items, _temp);
      $[4] = items;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    t3 = t5;
  }
  const sectionBarItems = t3;
  let t4;
  if ($[6] !== sectionBarItems) {
    t4 = sectionBarItems.map(_temp2);
    $[6] = sectionBarItems;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const sectionIds = t4;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      mode: "proximity"
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const activeSection = useActiveSection(sectionIds, t5);
  let t6;
  let t7;
  if ($[9] !== activeSection || $[10] !== api || $[11] !== sectionIds) {
    t6 = () => {
      if (!api) {
        return;
      }
      api.scrollTo(sectionIds.indexOf(activeSection));
    };
    t7 = [api, activeSection, sectionIds];
    $[9] = activeSection;
    $[10] = api;
    $[11] = sectionIds;
    $[12] = t6;
    $[13] = t7;
  } else {
    t6 = $[12];
    t7 = $[13];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      const handler = e => {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
          setDropdownOpen(false);
        }
      };
      document.addEventListener("mousedown", handler);
      return () => document.removeEventListener("mousedown", handler);
    };
    t9 = [];
    $[14] = t8;
    $[15] = t9;
  } else {
    t8 = $[14];
    t9 = $[15];
  }
  useEffect(t8, t9);
  const hasMainApply = !!(job.data.applicationUrl && job.data.applicationUrl.length > 2);
  const hasDirectApply = !!job.data.applicationUrlDirect;
  const hasApply = hasMainApply || hasDirectApply;
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      align: "center",
      duration: 15
    };
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== activeSection || $[18] !== sectionBarItems || $[19] !== t) {
    let t12;
    if ($[21] !== activeSection || $[22] !== t) {
      t12 = item_1 => <CarouselItem className="basis-auto pl-0" key={item_1.section}><li className={cn("flex whitespace-nowrap leading-none", activeSection === item_1.section ? "font-bold opacity-100" : "opacity-60")}><a aria-label={t[item_1.label as keyof TranslationsMap]} className="px-2 first:pl-4" data-source="lc" href={`#${item_1.section}`} onClick={handleNavigation}>{t[item_1.label as keyof TranslationsMap]}</a></li></CarouselItem>;
      $[21] = activeSection;
      $[22] = t;
      $[23] = t12;
    } else {
      t12 = $[23];
    }
    t11 = sectionBarItems.map(t12);
    $[17] = activeSection;
    $[18] = sectionBarItems;
    $[19] = t;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[24] !== t11) {
    t12 = <CarouselContent className="ease-in-out">{t11}</CarouselContent>;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== api) {
    t13 = <HungaryCarouselNavigation api={api} />;
    $[26] = api;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t12 || $[29] !== t13) {
    t14 = <div className="relative flex h-full w-full items-center overflow-hidden"><Carousel className="w-full" opts={t10} setApi={setApi}>{t12}{t13}</Carousel></div>;
    $[28] = t12;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== dropdownOpen || $[32] !== hasApply || $[33] !== hasDirectApply || $[34] !== hasMainApply || $[35] !== isLarge || $[36] !== job || $[37] !== t) {
    t15 = isLarge ? <>{hasMainApply && <ApplyButton className={applyButtonClass} job={job} />}{hasDirectApply && <ApplyButton className={applyButtonClass} direct={true} job={job} />}</> : hasApply && <div className="relative" ref={dropdownRef}><button className={cn(applyButtonClass, "h-12 px-4")} onClick={() => setDropdownOpen(_temp3)} type="button">{t.jobad_applyNow}</button>{dropdownOpen && <div className="absolute top-full right-0 z-50 mt-1 flex flex-col overflow-hidden rounded-lg bg-white shadow-lg">{hasMainApply && <ApplyButton className="rounded-none border-0 bg-white px-4 text-primary hover:bg-gray-100 hover:text-primary" job={job} variant="ghost" />}{hasDirectApply && <ApplyButton className="rounded-none border-0 bg-white px-4 text-primary hover:bg-gray-100 hover:text-primary" direct={true} job={job} variant="ghost" />}</div>}</div>;
    $[31] = dropdownOpen;
    $[32] = hasApply;
    $[33] = hasDirectApply;
    $[34] = hasMainApply;
    $[35] = isLarge;
    $[36] = job;
    $[37] = t;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== t15) {
    t16 = <div className="flex items-center justify-center gap-3 py-2 font-medium text-base md:leading-5 print:hidden">{t15}</div>;
    $[39] = t15;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== t14 || $[42] !== t16) {
    t17 = <nav className="outer-container sticky top-16 z-10 border-gray-200 border-b bg-gray-200 py-3 font-light text-lg md:py-1"><div className="inner-container flex items-center justify-between gap-4">{t14}{t16}</div></nav>;
    $[41] = t14;
    $[42] = t16;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  return t17;
}
function _temp3(o) {
  return !o;
}
function _temp2(item_0) {
  return item_0.section;
}
function _temp(item) {
  return item.section;
}
function HungaryCarouselNavigation(t0) {
  const $ = _c(11);
  const {
    api
  } = t0;
  let t1;
  if ($[0] !== api) {
    t1 = () => {
      api?.scrollPrev();
      api?.scrollPrev();
    };
    $[0] = api;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const scrollMultiplePrev = t1;
  let t2;
  if ($[2] !== api) {
    t2 = () => {
      api?.scrollNext();
      api?.scrollNext();
    };
    $[2] = api;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const scrollMultipleNext = t2;
  let t3;
  if ($[4] !== scrollMultiplePrev) {
    t3 = <CarouselPrevious className="absolute -left-2 z-20 size-14 rounded-none border-none bg-gradient-to-r from-gray-200 via-gray-200 to-transparent shadow-none disabled:hidden" onClick={scrollMultiplePrev} />;
    $[4] = scrollMultiplePrev;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== scrollMultipleNext) {
    t4 = <CarouselNext className="absolute -right-9 z-20 size-14 rounded-none border-none bg-gradient-to-l from-gray-200 via-gray-200 to-transparent shadow-none disabled:hidden" onClick={scrollMultipleNext} />;
    $[6] = scrollMultipleNext;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}